import React from 'react';
import { usePageBanners } from '../../../hooks/usePageBanners';
import PageBanner from '../PageBanner/PageBanner';
import './ProductsHero.css';

const SECTION_MAP = {
  Task: 'Products > Task',
  Tasks: 'Products > Task',
  Documents: 'Products > Document',
  'Credentials Vault': 'Products > Credentials Vault',
};

const ProductsHero = ({ title = 'Products', subtitle = 'Task and Document management designed to streamline your business operations', bannerSection, children }) => {
  const section = bannerSection || SECTION_MAP[title];
  const { hasDynamicBanner, banners } = usePageBanners(section || null);

  return (
    <section className="products-hero">
      {hasDynamicBanner && <PageBanner banners={banners} />}
      {!hasDynamicBanner && (
        <div className="products-hero-title-section products-hero-title-section--standalone">
          <div className="container">
            <div className="products-hero-content">
              <h1 className="products-title">
                {title}
              </h1>
              {!children && (
                <p className="products-subtitle">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
        </div>
      )}
      {children && (
        <div
          className={`products-hero-subheading-section${
            hasDynamicBanner ? ' products-hero-subheading-section--after-banner' : ''
          }`}
        >
          <div className="container">
            <div className="products-subtitle products-subtitle-multi">
              {children}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductsHero;
